import React from "react";
import SupportPatientHeader from "../SupportPatientHeader";
import Footer from "../Footer";

const SupportPatientProduct = () => {
  return (
    <>
      <SupportPatientHeader />
      <main className="inner-page">
        <section className="container">
          <div className="row">
            <div className="col-sm-12">
              <h1 className="text-uppercase">Product</h1>
              <div className="spacer-1"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div
                className="card bg-blue rounded-0 border-0 text-center p-4 h-100 d-flex justify-content-center"
                style={{ minHeight: "500px" }}
              >
                <p className="mb-0 fs-24 fw-bold text-white lh-sm">
                  Information for Patients and Carers 
                  <br /><br />
                  Patient and carer education can be customised, for example, what to expect, <br />
                  treatment regimen, side effect management, links to patient organisations,<br /> 
                  patient videos etc… 
                  <br /><br />
                  Patients can read, download, print, watch, or order printed copies. 
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default SupportPatientProduct;
